import { useEffect, useRef, useState } from "react";
import { BrowserRouter } from "react-router-dom";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/material/styles";

import { Amplify } from "aws-amplify";
import awsExports from "./config/aws-exports";

import Header from "./mainContainer/Header";
import MainConteiner from "./mainContainer/MainConteiner";
import Footer from "./mainContainer/Footer";
import { lastSelectedPeriod, userState } from "./interface/MainInterface";
import * as AuthMain from "./auth/AuthMain";
import "./App.css";
import "./css/reset.css";
// import "./css/swiper-bundle.min.css";
import "./css/common.css";
import "./css/commonMobile.css";
import { Box } from "@mui/material";

Amplify.configure(awsExports);

let userParam: userState = {
  id: "",
  name: "",
  company: "",
  isAuth: false,
  isPermission: false,
  isAdmin: false,
  isSuperAdmin: false,
};

const theme = createTheme({
  typography: {
    fontFamily: "Pretendard, sans-serif",
  },
  zIndex: { drawer: 990, modal: 990 },
});

const LayoutDivider = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  minHeight: "61px !important",
  padding: theme.spacing(0, 0),
  justifyContent: "flex-end",
}));

function App() {
  const headerRef: any = useRef();
  const [userState, setUserState] = useState<userState | any>(null);
  const [selectedMenu, setSelectedMenu] = useState("");
  const [briefList, setBriefList] = useState<any>([]);
  const [searchText, setSearchText] = useState("");
  const [selectedPeriod, setSelectedPeriod] = useState("recent");
  const [lastEvalKey, setLastEvalKey] = useState<any>("");
  const [nowPageSize, setNowPageSize] = useState(9);
  const [lastScrollPos, setLastScrollPos] = useState(-1);
  const [needRefresh, setNeedRefresh] = useState(true);

  useEffect(() => {
    window.localStorage.removeItem("scrollPosition");

    // 사용자의 마지막 검색기간을 세팅
    const cookieLastPeriod: any = window.localStorage.getItem(lastSelectedPeriod);
    if (cookieLastPeriod !== undefined && cookieLastPeriod !== "" && cookieLastPeriod !== null) {
      setSelectedPeriod(cookieLastPeriod);
    } else {
      setSelectedPeriod("recent");
    }

    return () => {
      setUserState(null);
      setSelectedMenu("");
    };
  }, []);

  async function setUserInfo() {
    // 세션체크
    const result = AuthMain.getSession();
    if (result !== null) {
      userParam.isAuth = true;

      userParam.id = result.id;
      userParam.name = result.name;

      userParam.isAdmin = result.isAdmin;
      userParam.isSuperAdmin = result.isSuperAdmin;
      userParam.company = result.user_info1;
    } else {
      const result = await AuthMain.checkAuthenticated();
      userParam.isAuth = true;
      // 사용자 정보 조회
      const userAttr = await AuthMain.getUserAttr();
      userParam.id = userAttr.id;
      userParam.name = userAttr.name;
      // 사용권한 체크
      const adminInfo = await AuthMain.checkPermission();
      userParam.isPermission = adminInfo.isPermission;
      userParam.isAdmin = adminInfo.isAdmin;
      userParam.isSuperAdmin = adminInfo.isSuperAdmin;
      userParam.company = adminInfo.company;
    }

    // const result = await AuthMain.checkAuthenticated();
    // if (result) {
    //   userParam.isAuth = true;
    //   // 사용자 정보 조회
    //   const userAttr = await AuthMain.getUserAttr();
    //   userParam.id = userAttr.id;
    //   userParam.name = userAttr.name;
    //   // 사용권한 체크
    //   const adminInfo = await AuthMain.checkPermission();
    //   userParam.isPermission = adminInfo.isPermission;
    //   userParam.isAdmin = adminInfo.isAdmin;
    //   userParam.isSuperAdmin = adminInfo.isSuperAdmin;
    //   userParam.company = adminInfo.company;
    // } else {
    //   const result = await AuthMain.getSession();
    //   if (result) {
    //     userParam.isAuth = true;

    //     userParam.id = result.id;
    //     userParam.name = result.name;

    //     userParam.isAdmin = result.isAdmin;
    //     userParam.isSuperAdmin = result.isSuperAdmin;
    //     userParam.company = result.user_info1;
    //   }
    // }
    setUserState(userParam);
  }

  useEffect(() => {
    setUserInfo();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        {userState && (
          <BrowserRouter>
            <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
              {selectedMenu === "/main" || selectedMenu === "/signin" || selectedMenu === "/hartlogin" ? (
                <></>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                  <Header ref={headerRef} userState={userState} />
                  <LayoutDivider />
                </Box>
              )}
              <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", marginBottom: "auto" }}>
                <MainConteiner
                  userState={userState}
                  setSelectedMenu={setSelectedMenu}
                  briefList={briefList}
                  setBriefList={setBriefList}
                  searchText={searchText}
                  setSearchText={setSearchText}
                  selectedPeriod={selectedPeriod}
                  setSelectedPeriod={setSelectedPeriod}
                  lastEvalKey={lastEvalKey}
                  setLastEvalKey={setLastEvalKey}
                  nowPageSize={nowPageSize}
                  setNowPageSize={setNowPageSize}
                  lastScrollPos={lastScrollPos}
                  setLastScrollPos={setLastScrollPos}
                  needRefresh={needRefresh}
                  setNeedRefresh={setNeedRefresh}
                />
              </Box>
              <Box sx={{ flexGrow: "1" }}></Box>
              {selectedMenu === "/brief" || selectedMenu === "/main" || selectedMenu === "/signin" || selectedMenu === "/hartlogin" ? (
                <></>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
                  <Footer />
                </Box>
              )}
            </Box>
          </BrowserRouter>
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
